import { Typography } from "@mui/material";
import React from "react";

import TaskToolTip from "./taskToolTip";

export default function TaskFieldTypography(props) {
  const { id, readOnly, color, style, variant, toolTip, label } = props;

  return (
    <TaskToolTip title={toolTip}>
      <Typography
        color={color}
        id={id}
        variant={variant}
        readOnly={readOnly}
        style={style}
      >
        {label}
      </Typography>
    </TaskToolTip>
  );
}
